import { useState } from "react";
import _ from "lodash";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { dataValidator } from "../../tools/dataValidator";

import { getLabel } from "../../tools/Dictionary";

const ProcessDesignerGroup = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const OnCloseModal = props.OnCloseModal;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const TempId = props.TempId;
  const Group = props.Group;
  const Process = props.Process;
  const ParentGroup = props.ParentGroup;
  const Position = props.Position;
  const OnAddGroup = props.OnAddGroup;
  const Data = props.Data;


  //State
  const [form, setForm] = useState(() => {

    if (Data) return _.cloneDeep(Data);
    return {
      title: ""
    } 
  });
  const [error, setError] = useState({

  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onChangeTitle = (e) =>
  {

    let title = e.target.value;

    onValidateField("title", title);

    setForm(form => ({
      ...form,
      title
    }));
  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "title";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:50"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };



  const onClickConfirm = () =>
  {

    try{

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));

      //check if title is already used

      if (!Data && Group.findIndex(g => g.title == form.title) > -1) throw new Error(getLabel("ProcessDesignerGroup", "The title is already used by another group. Please choose a unique title for this group."));


      let newGroup = {}

      if (Data){
        newGroup = form;
      }else{
        newGroup = {
          _id: TempId,
          process: Process._id,
          title: form.title,
          entry: [],
          position: Position,
          parentGroup: ParentGroup
        };
      }

      OnAddGroup(newGroup);

      OnCloseModal();


    }catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };

  const onClickContext = (e) =>
  {
    e.stopPropagation();
  };


  console.log(Position);


  return (
    <div className="page_modal_background" onContextMenu={onClickContext}>
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesigner", "Group")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesignerSchemaModal", "Title")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["title"] ? "page_modal_body_col_input_error" : "")}
                value={form.title || ""}
                onChange={onChangeTitle}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
                autoFocus={true} 
              />
              {error["title"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["title"]}
                </div>
              }
            </div>
          </div>  
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerGroup